module.exports = __webpack_public_path__ + "8b0e6c87793bd1348d8a2aadb1f04bc0.png";